export enum EChatBotsMessengers {
    instagram = 'instagram',
    telegram = 'telegram',
    messenger = 'messenger',
    whatsapp = 'whatsapp',
    tiktok = 'tiktok',
    viber = 'viber',
    facebook = 'facebook',
    snapchat = 'snapchat',
    skype = 'skype',
    vk = 'vk',
    ok = 'ok',
    line = 'line',
    kik = 'kik',
    email = 'email',
    phone = 'phone',
}
